module.exports = __webpack_public_path__ + "img/img45.328b386b.png";